import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

//import DialogLoader from '../../../components/Loader/DialogLoader';
import RichTextEditor from 'react-rte';
import { InputBaseField, SelectField, TextareaField } from '../../../components/InputField/InputField';
import { Label, DraggableComponent, LabelNoColumn } from '../../../components/UiElements/UiElements'
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "./../../../components/Message/Alert";
import useStyles from "./styles";
import { validateEmail, validatePhoneNumber, handleNumberKeyPress } from '../../../../src/components/Common/Extensions';
import Logo from '../../../assets/img/Figger-foundation-logo.svg';
import googleGif from "../../../assets/img/common/Google-1.jpg"
import BBBGif from "../../../assets/img/common/BBB-1.jpg"
import TwitterGif from "../../../assets/img/common/twitter-1.jpg"
import TrustpilotGif from "../../../assets/img/common/trust_pilot_1.jpg"
import FacebookGif from "../../../assets/img/common/Facebook-1.jpg"
import StarGif from "../../../assets/img/Top-Stars-Animation-.gif";
import Loader from '../../../components/Loader/Loader';
function ReviewRequest({ dialogOpenClose, handleClose, handleSuccessClose, applicationsCount, applicationType, applicationId, ...props }) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [totalRecepients, setTotalRecepients] = useState(applicationsCount)
    const [state, setState] = useState({ subject: 'Your Feedback Matters: Help Us Empower the Community' });
    const { showMessage } = props;

    const handleChange = e => {
        const { name, value } = e.target;

        if (value.trim() === "" && value !== "") {
            return;
        }

        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const toolbarConfig = {

        display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'BLOCK_TYPE_DROPDOWN'],
        INLINE_STYLE_BUTTONS: [
            { label: 'Bold', style: 'BOLD', className: 'custom-css-class' },
            { label: 'Italic', style: 'ITALIC' },
            { label: 'strikethrough', style: 'STRIKETHROUGH' },

        ],
        BLOCK_TYPE_BUTTONS: [
            { label: 'UL', style: 'unordered-list-item' },
            { label: 'OL', style: 'ordered-list-item' },
            { label: 'Blockquote', style: 'blockquote' }
        ],
        BLOCK_TYPE_DROPDOWN: [
            { label: 'Style', style: 'unstyled' },
            { label: 'Heading Large', style: 'header-one' },
            { label: 'Heading Medium', style: 'header-two' },
            { label: 'Heading Small', style: 'header-three' }
        ]

    };

    const [templateState, setTemplateState] = useState("Google");
    const [defaultTemplate, setDefaultTemplate] = useState("Google");
    const [emailTemp, setEmailTemp] = useState([]);
    const socialIcons = [
        { src: "https://figgersfoundation.org/ff-email-assets/icons/fb.png", url: "https://www.facebook.com/Figgers-Foundation-2265042470489249/" },
        { src: "https://figgersfoundation.org/ff-email-assets/icons/insta.png", url: "https://instagram.com/figgersfoundation?igshid=fhe096n05fqb" },
        { src: "https://figgersfoundation.org/ff-email-assets/icons/xicon.png", url: "https://twitter.com/figgfoundation" },
        { src: "https://figgersfoundation.org/ff-email-assets/icons/lnk.png", url: "https://www.linkedin.com/company/the-figgers-foundation/" },
    ];

    const regex = /(<([^>]+)>)/ig;
    const regexSpaces = /((&nbsp;))*/gmi;

    function isEditorEmpty(_editorValue) {
        let editorDetail = _editorValue.toString('html').replace(regex, '');
        let isEmpty = false;
        if (editorDetail.trim() === ""
            || editorDetail.trim().length === 0
            || editorDetail == "<p><br></p>"
            || !!editorDetail.replace(regex, "") == ""
            || !!editorDetail.replace(regexSpaces, '') == ""
            || editorDetail == "<p></p>") {
            isEmpty = true;
        }
        return isEmpty;
    }

    const MAX_EDITOR_LENGTH = 2000;
    const preGeneratedText = "<p>You are receiving this email because you received a free device and service from the Figgers Foundation. To continue delivering impactful resources, we kindly request your feedback by leaving a 5-star review.</br></br>Taking just 2 minutes of your time, please click the links below to share your experience: </p>";
    const preGeneratedText2 = "<p>Your 5-star review enables us to enhance our Free services to reach more individuals in need. Together, we can create a brighter future for our community.</p>";
    const [EDITOR_CHAR_LENGTH, setEDITOR_CHAR_LENGTH] = useState(preGeneratedText.length);
    const [editorValue, setEditorValue] = useState(RichTextEditor.createValueFromString(preGeneratedText, 'html'));

    const handleEditorChange = (editorValue) => {

        const editorDetail = editorValue.toString('html').replace(regex, '');

        if (editorDetail && editorDetail.length > (MAX_EDITOR_LENGTH)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: true
            }));
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: false
            }));
        }
        setEDITOR_CHAR_LENGTH(editorDetail.length);

        if (!isEditorEmpty(editorValue))
            errorMessages.errorMessage = false;
        setEditorValue(editorValue);
    }


    const [errorMessages, setErrorMessages] = useState({

    });
    const changeTemplate = (e) => {
        //debugger;
        //const { name, value } = e.target;
        //setTemplateState(value);

        //var obj = emailTemp.find(obj => obj.value == value)
        //var id = obj.tempId

        //setState(prevState => ({
        //    ...prevState,
        //    templateId: id,
        //    templateCode: value

        //}))
        const { name, value } = e.target;
        setTemplateState(value);
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))

    }

    const Validate = (errorList) => {
        //if (!state.title.trim()) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorTitle: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorTitle: false
        //    }));
        //}

        if (!state.subject.trim()) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSubject: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorSubject: false
            }));
        }
        if (!state.templateId || state.templateId == 'Select Template') {
            setErrorMessages(prevState => ({
                ...prevState,
                errorTemplate: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorTemplate: false
            }));
        }

        const editorDetail = editorValue.toString('html').replace(regex, '');
        if (isEditorEmpty(editorValue)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorMessage: false
            }));
        }


        if (editorDetail && editorDetail.length > MAX_EDITOR_LENGTH) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEditorMaxValue: false
            }));
        }

    }
    const sendReviewEmail = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            var method = "fdnmcchromicconnect/sendReviewRequestEmailToDeliveredRecepients";
            state.reviewStatus = 'Submitted';
            var obj = emailTemp.find(obj => obj.value == state.templateId)
            state.templateId = parseInt(obj.tempId);
            state.templateCode = obj.value;
            state.message = editorValue.toString('html');
            state.applicationId = applicationId
            state.applicationType = applicationType;
            state.signalRConnectionId = sessionStorage.getItem('signalRConnectionId');
            PostDataAPI(method, state, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        handleSuccessClose("Review requests are on the way, you will be notified shortly.");
                    }
                    else {
                        showMessage("Error", "Error sending review request, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        }

    }

    const loadEmailTemplate = () => {
        var params = {
            code: "get_reviews_template",
            parameters: ['']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            setEmailTemp([]);
            if (result.success && result.data != null) {
                const newData = [{ text2: 'Select Template', text1: '', t3: '' }, ...result.data];
                const filteredData = newData.filter(item => item.text2 !== 'All');
                filteredData.map((item, i) => {
                    setEmailTemp(prevState => [...prevState, { value: item.text2, label: item.text2, att: item.t3, tempId: item.text1 }]);
                    if (item.text2 === 'Google') {
                        setTemplateState(item.text2);
                        setDefaultTemplate(item.text2);
                        setState(prevState => ({
                            ...prevState,
                            'templateId': item.text2
                        }))
                    }
                })
            }
        })
    }

    useEffect(() => {
        //console.log(applicationIds)
        loadEmailTemplate()

    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={DraggableComponent}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Review Request</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>


                    {isLoading ? <Loader></Loader> : ''}
                    <Scrollbars autoHeight autoHeightMax={550}>
                        <div className={classes.content}>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>


                                    <Grid container spacing={3}>

                                        {/*<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>*/}
                                        {/*    <Grid row >*/}
                                        {/*        <Label title="Title" size={12} mandatory={true} />*/}
                                        {/*        <InputBaseField*/}
                                        {/*            name="title"*/}
                                        {/*            value={state.title}*/}
                                        {/*            onChange={handleChange}*/}
                                        {/*            placeholder="Title"*/}
                                        {/*            type="text"*/}
                                        {/*            MaxLength={50}*/}
                                        {/*        />*/}
                                        {/*        {errorMessages.errorTitle && !state.title ? (<FormHelperText style={{ color: "red" }} >*/}
                                        {/*            Please enter Title*/}
                                        {/*        </FormHelperText>) : ('')}*/}
                                        {/*    </Grid>*/}

                                        {/*</Grid>*/}

                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Subject" size={12} mandatory={true} />
                                                <InputBaseField
                                                    name="subject"
                                                    value={state.subject}
                                                    onChange={handleChange}
                                                    placeholder="Subject"
                                                    type="text"
                                                    MaxLength={80}
                                                />
                                                {errorMessages.errorSubject && !state.subject ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter Subject
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>


                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <Label title="Ask For Review Template" size={12} mandatory={true} />
                                                {/*<SelectField*/}
                                                {/*    options={emailTemp}*/}
                                                {/*    onChange={changeTemplate}*/}
                                                {/*    defaultTemplate={defaultTemplate}*/}
                                                {/*    name="templateId"*/}
                                                {/*    value={state.templateId}*/}
                                                {/*/>*/}
                                                <Select
                                                    size="small"
                                                    native
                                                    name="templateId"
                                                    value={state?.templateId}
                                                    onChange={changeTemplate}
                                                    placeholder="Select"
                                                    label="Select"
                                                    className={classes.selectBaseInput}
                                                >
                                                    {emailTemp.map(option =>
                                                        <option value={option.value}>{option.label}</option>
                                                    )
                                                    }
                                                </Select>
                                                {errorMessages.errorTemplate && (!state.templateId || state.templateId == 'Select Template') ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select template
                                                </FormHelperText>) : ('')}
                                            </Grid>

                                        </Grid>

                                    </Grid>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <Grid row >
                                                <LabelNoColumn title={"Total Recipients: " + totalRecepients} size={12} />
                                            </Grid>

                                        </Grid>

                                    </Grid>



                                    <Grid container spacing={2} className={classes.textEditor}>
                                        <Grid item sm={12} md={12} lg={12} xl={12}>
                                            <Grid row >
                                                <Label title="Message" size={12} mandatory={true} />
                                                <RichTextEditor
                                                    value={editorValue}
                                                    onChange={handleEditorChange}
                                                    className={classes.note}
                                                    placeholder="Message goes here..."
                                                    toolbarConfig={toolbarConfig}
                                                >
                                                </RichTextEditor>

                                                <div className={classes.DisplayBlock}> {EDITOR_CHAR_LENGTH + '/' + MAX_EDITOR_LENGTH} </div>

                                                {errorMessages.errorMessage ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter message
                                                </FormHelperText>) : ('')}

                                                {errorMessages.errorEditorMaxValue && EDITOR_CHAR_LENGTH > MAX_EDITOR_LENGTH ?
                                                    (<FormHelperText style={{ color: "red" }} >Maximum {MAX_EDITOR_LENGTH} characters allowed</FormHelperText>)
                                                    : ('')
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>


                                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>


                                    <div className={classes.templateContainer}>
                                        <div className={"tempHeader"} style={{
                                            background: "#282827"
                                        }}>
                                            <Grid container alignItems='center'>
                                                <Grid item lg={6} md={6}>
                                                    <img src={Logo} />
                                                </Grid>
                                                <Grid item lg={6} md={6} className={"textRight"}>
                                                    <img src={StarGif} />
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div className={"tempHeaderBottom"}>
                                            <h3> Your Feedback Matters </h3>
                                        </div>

                                        <div className={"tempContent"}>
                                            <h1>{state.title}</h1>
                                            <h4>{state.subject}</h4>
                                            <Grid container>
                                                <Grid item sm={12} md={12} lg={12}>
                                                    <p dangerouslySetInnerHTML={{
                                                        __html: editorValue.toString('html'),
                                                    }}></p>


                                                    {templateState !== "All" ?
                                                        <div className={classes.brandBox}>
                                                            {/*<a>Link to Google Reviews</a>*/}
                                                            <img src={
                                                                templateState == "Google" ? googleGif : templateState == "Accredited Business" ? BBBGif :
                                                                    templateState == "Twitter" ? TwitterGif : templateState == "Trustpilot" ? TrustpilotGif :
                                                                        templateState == "Facebook" ? FacebookGif : ''} />
                                                        </div>
                                                        : ''}
                                                </Grid>

                                                <p dangerouslySetInnerHTML={{
                                                    __html: preGeneratedText2.toString('html'),
                                                }}></p>

                                            </Grid>

                                            <div>
                                                <p>Sincerely, </p>
                                                <p> </p><b>The Figgers Foundation.</b>
                                            </div>
                                        </div>
                                        <div className={"tempHeaderBottom"}>
                                            <h3> Help Us Empower the Community </h3>
                                        </div>
                                        <Grid container>
                                            <Grid lg={12} md={12} sm={12}>
                                                <div className={classes.templateFooter}>
                                                    <Grid container>
                                                        <Grid item lg={6} md={6} sm={6}>
                                                            <a href='https://figgersfoundation.org/' target='_blank' title='Figgers Foundation'>FiggersFoundation.org</a>
                                                        </Grid>
                                                        <Grid item lg={6} md={6} sm={6}>
                                                            <div className={classes.IconsMain}>
                                                                {socialIcons.map((icon, index) => (
                                                                    <a key={index} href={icon.url} target="_blank" rel="noopener noreferrer">
                                                                        <img src={icon.src} alt={`Social Icon ${index + 1}`} className={classes.SocialLogo} />
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        </Grid>


                                                    </Grid>
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </div>


                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={sendReviewEmail}>Send</Button>

                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(ReviewRequest);
